import React, { useState } from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import { agentsData } from "Stores/agentsData";
import AgentSelect from "./AgentSelect";
import { defaultTimezone } from "./DayOfWeekField";
import { SetupPage, When, Branch, SequenceField, NotifyStep, openInBuilder } from "./SetupFlow";

const CreateReplyRouter = observer(() => {
  const history = useHistory();
  const [name, setName] = useState("");
  const [channel, setChannel] = useState("email"); // email | linkedin
  const [positiveAction, setPositiveAction] = useState("task"); // task | enroll | notify
  const [sequenceId, setSequenceId] = useState("");
  const [sequenceName, setSequenceName] = useState("");
  const [stopOnNegative, setStopOnNegative] = useState(true);
  const [notifyMode, setNotifyMode] = useState("ON_FAILURE");
  const [saving, setSaving] = useState(false);
  const timezone = defaultTimezone();

  const needsSequence = positiveAction === "enroll";
  const canSubmit = !needsSequence || !!sequenceId;

  const buildPayload = () => ({
    name: name.trim() || "Reply router",
    channel,
    positiveAction,
    positiveSequenceId: needsSequence ? sequenceId : undefined,
    stopOnNegative,
    notifyMode,
    timezone
  });

  const submit = async () => {
    if (!canSubmit) return;
    setSaving(true);
    const agent = await agentsData.createReplyRouter(buildPayload());
    setSaving(false);
    if (agent && agent.id) history.push(`/agents/${agent.id}`);
  };

  const customize = () => { if (canSubmit) openInBuilder(history, "reply-router", buildPayload(), setSaving); };

  return (
    <SetupPage
      title="Hire · Reply router"
      name={{ value: name, onChange: setName, placeholder: "Reply router" }}
      bar={{ canSubmit, saving, onCreate: submit, onCustomize: customize, customizeDisabled: !canSubmit, onCancel: () => history.push("/agents"), reason: "Pick a sequence to create it." }}>
      <When icon="positive_reply" title="A contact replies">
        <AgentSelect value={channel} onChange={setChannel} options={[
          { value: "email", label: "To an email" },
          { value: "linkedin", label: "On LinkedIn" }
        ]} />
      </When>
      <Branch title="When the reply is…" rows={[
        {
          label: "If the reply is positive",
          body: (
            <>
              <AgentSelect value={positiveAction} onChange={setPositiveAction} options={[
                { value: "task", label: "Create a call task for me" },
                { value: "enroll", label: "Enroll them in a sequence" },
                { value: "notify", label: "Just tell me" }
              ]} />
              {needsSequence && <SequenceField id={sequenceId} name={sequenceName} onPick={s => { setSequenceId(s.id); setSequenceName(s.name); }} />}
            </>
          )
        },
        {
          label: "If it's negative",
          body: (
            <label className="ag-sf__check">
              <input type="checkbox" checked={stopOnNegative} onChange={e => setStopOnNegative(e.target.checked)} />
              <span>Stop their sequence</span>
            </label>
          )
        },
        { label: "If anything else", body: notifyMode === "OFF" ? null : <span className="af-row__text">Tells you</span> }
      ]} />
      <NotifyStep title="Then, for everyone: Tell me" value={notifyMode} onChange={setNotifyMode} />
    </SetupPage>
  );
});

export default CreateReplyRouter;
